export default __webpack_public_path__ + "static/media/classesScheduled.63257095.svg";